/**
 * Custom Accordion Functionality
 * Handles FAQ accordion toggle behavior
 */

(function() {
  'use strict';

  // Only declare the class if it doesn't exist
  if (typeof window.CustomAccordion !== 'undefined') {
    return;
  }

  window.CustomAccordion = class CustomAccordion {
    constructor(section) {
      this.section = section;
      this.faqItems = section.querySelectorAll('[data-faq-item]');
      this.init();
    }

    init() {
      this.faqItems.forEach(item => {
        const trigger = item.querySelector('[data-faq-trigger]');
        const content = item.querySelector('[data-faq-content]');
        
        if (trigger && content) {
          // Remove existing listeners to prevent duplicates
          const newTrigger = trigger.cloneNode(true);
          trigger.parentNode.replaceChild(newTrigger, trigger);
          
          newTrigger.addEventListener('click', () => this.toggleFAQ(item, content));
        }
      });
    }

    toggleFAQ(item, content) {
      const isActive = item.classList.contains('active');
      
      if (isActive) {
        // Close the item
        this.closeFAQ(item, content);
      } else {
        // Close all other items in this section only
        this.closeAllFAQs();
        
        // Open this item
        this.openFAQ(item, content);
      }
    }

    openFAQ(item, content) {
      item.classList.add('active');
      
      // Set max-height to scrollHeight for smooth animation
      content.style.maxHeight = content.scrollHeight + 'px';
    }

    closeFAQ(item, content) {
      item.classList.remove('active');
      content.style.maxHeight = '0';
    }

    closeAllFAQs() {
      this.faqItems.forEach(item => {
        const content = item.querySelector('[data-faq-content]');
        this.closeFAQ(item, content);
      });
    }
  };

  // Initialize all accordion sections
  function initializeAccordions() {
    const accordionSections = document.querySelectorAll('.custom-accordion-section');
    
    accordionSections.forEach(section => {
      // Check if already initialized
      if (!section.hasAttribute('data-accordion-initialized')) {
        new window.CustomAccordion(section);
        section.setAttribute('data-accordion-initialized', 'true');
      }
    });
  }

  // Initialize accordion when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAccordions);
  } else {
    initializeAccordions();
  }

  // Shopify theme editor support
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.custom-accordion-section');
      if (section) {
        section.removeAttribute('data-accordion-initialized');
        new window.CustomAccordion(section);
        section.setAttribute('data-accordion-initialized', 'true');
      }
    });

    document.addEventListener('shopify:block:select', (event) => {
      const faqItem = event.target.closest('[data-faq-item]');
      if (faqItem) {
        const content = faqItem.querySelector('[data-faq-content]');
        const accordion = faqItem.closest('.custom-accordion-section');
        
        if (accordion && content) {
          const instance = new window.CustomAccordion(accordion);
          instance.openFAQ(faqItem, content);
        }
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('.custom-accordion-section');
      if (section) {
        section.removeAttribute('data-accordion-initialized');
      }
    });
  }
})();